import React from 'react'
import { useSkin } from '@hooks/useSkin'

const ThemeAwareIcon = ({ src, alt = 'icon', className = '' }) => {
    const { skin } = useSkin()

    const isDarkMode = skin === 'dark'

    const iconStyle = {
        width: '25px',
        height: '25px',
        marginRight: '10px',
        // Apply a filter to invert colors when in dark mode
        filter: isDarkMode ? 'brightness(0) invert(1)' : 'none'
    }

    return <img src={src} alt={alt} style={iconStyle} className={className} />
}

export default ThemeAwareIcon